import styles from "./HotspotImage.module.css";
import Button from "react-bootstrap/Button";
import { useRef , useState} from "react";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { currentHotspotSelector } from "../../../hooks/store/getters";
import { setTourSceneHotspotSelector } from "../../../hooks/store/setters";
import { uploadHotspotImage } from "../../../services/CloudStorage.service";
import ProgressBar from 'react-bootstrap/ProgressBar';

const HotspotImage = () => {
    
    const imageInputRef = useRef(null);
    
    const setSceneHotspot = useAppStore(setTourSceneHotspotSelector);
    const currentHotspot = useAppStore(currentHotspotSelector);
    const [progress, setProgress] = useState(null);

    const { image, name } = currentHotspot;
    
    
    const handleImageChange = async (event) => {
        const file = URL.createObjectURL(event.target.files[0]);
        setSceneHotspot({ image: { file } });

        const fileUploadUrl = url => setSceneHotspot({ image: { url, file } });

        uploadHotspotImage(event.target.files[0], setProgress, fileUploadUrl);
    };
    
    return (
        <div className={styles.hotspotImage}>
            {
                (image.url || image.file) && (
                    <img src={image.url || image.file} alt={name} />
                )
            }
            <Button
                variant="dark"
                onClick={() => imageInputRef.current.click()}
                disabled={progress}
            >
                { (image.url || image.file) && !progress ? 'Change' : 'Upload' } Image 
                {progress ? (
                    <ProgressBar animated now={progress} label={`${progress}%`} />
                ) : null}
             </Button>
            
            <input
                type="file"
                id="upload"
                hidden
                ref={imageInputRef}
                onChange={handleImageChange}
            />
            
        </div>
    );
};

export default HotspotImage;